import { mediaUrl } from "@/lib/api";

const PHOENIX = "America/Phoenix";

export const toPlayable = (r) => {
  if (!r || !r.preview_url) return null;
  return {
    id: r.id,
    title: r.title,
    artist: r.artist || "P. Frazy",
    artwork: mediaUrl(r.artwork_url) || "/assets/img/logo.png",
    src: mediaUrl(r.preview_url),
    peaks: r.peaks || [],
    bpm: r.bpm || 90,
    full: Boolean(r.full_song),
  };
};

export const artworkOf = (r, size = 640) => {
  const u = r?.artwork_url;
  if (!u) return null;
  if (u.startsWith("/api")) return mediaUrl(u);
  // seed local assets exist at multiple sizes
  return u;
};

export const fmtReleaseDate = (iso, opts = {}) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-US", {
      weekday: opts.weekday ? "long" : undefined,
      month: "long", day: "numeric", year: "numeric",
      timeZone: PHOENIX,
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const fmtShortDate = (iso) => {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: PHOENIX }).format(new Date(iso));
  } catch { return iso; }
};

export const countdownParts = (iso) => {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const diff = target - Date.now();
  if (diff <= 0) return { done: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { done: false, days, hours, minutes, seconds };
};
